function progress() {
    return {
        componentName: 'progress',
        baseStyle: {
            borderRadius: '9999px'
        }
    };
}

export { progress as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvZ3Jlc3MuanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy90aGVtZS9jb21wb25lbnRzL3Byb2dyZXNzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IENvbXBvbmVudFN0eWxlIH0gZnJvbSAnLi4vdHlwZXMnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBwcm9ncmVzcygpOiBDb21wb25lbnRTdHlsZSB7XG4gIHJldHVybiB7XG4gICAgY29tcG9uZW50TmFtZTogJ3Byb2dyZXNzJyxcbiAgICBiYXNlU3R5bGU6IHtcbiAgICAgIGJvcmRlclJhZGl1czogJzk5OTlweCdcbiAgICB9XG4gIH07XG59XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRWMsU0FBVSxRQUFRLEdBQUE7SUFDOUIsT0FBTztBQUNMLFFBQUEsYUFBYSxFQUFFLFVBQVU7QUFDekIsUUFBQSxTQUFTLEVBQUU7QUFDVCxZQUFBLFlBQVksRUFBRTtBQUNmO0tBQ0Y7QUFDSDs7OzsifQ==
